import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { isNumber } from '@cutwise/utils';
import { getFrameUrl } from '@/media/helpers/getFrameUrl';
function FSetImage(props) {
    const { mediaSubFile, previewFrame, ...rest } = props;
    return (_jsx("img", { draggable: "false", src: getFrameUrl(mediaSubFile, isNumber(previewFrame) ? previewFrame : mediaSubFile.firstFrame), alt: "", ...rest }));
}
export default memo(FSetImage);
